(() => {
  if (window.RogueRedesignLoaded) return;
  window.RogueRedesignLoaded = true;

  document.addEventListener('click', (event) => {
    const accordionButton = event.target.closest('[data-rr-accordion-button]');
    if (accordionButton) {
      const panel = document.getElementById(accordionButton.getAttribute('aria-controls'));
      if (!panel) return;
      const expanded = accordionButton.getAttribute('aria-expanded') === 'true';
      accordionButton.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      return;
    }

    const descriptionButton = event.target.closest('[data-rr-description-toggle]');
    if (descriptionButton) {
      const description = descriptionButton.closest('.rr-description');
      const expanded = descriptionButton.getAttribute('aria-expanded') === 'true';
      descriptionButton.setAttribute('aria-expanded', String(!expanded));
      descriptionButton.textContent = expanded ? 'Read More' : 'Read Less';
      description.classList.toggle('is-open', !expanded);
      return;
    }

    const pauseButton = event.target.closest('[data-rr-marquee-pause]');
    if (pauseButton) {
      const strip = pauseButton.closest('.rr-strip');
      const paused = strip.classList.toggle('is-paused');
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.textContent = paused ? 'Play' : 'Pause';
    }
  });
})();
